export default __webpack_public_path__ + "static/molaschi-c05dbdc796f19fee2ae8717614eaa123.jpg";